<header class="app-header" role="banner">
    <mat-toolbar color="primary" class="app-toolbar toolbar--light">

        <!-- Left: Logo -->
        <div class="toolbar-section left">
            <button type="button" class="logo-btn" aria-label="Veralora Logo" [routerLink]="['/documents']">
                <img src="/assets/logo.svg" alt="Veralora Logo" class="logo-img" />
            </button>
        </div>

        <!-- Center: Page Title -->
        <div class="toolbar-section center">
        </div>

        <!-- Right: Actions -->
        <div class="toolbar-section right">
            <button matIconButton (click)="logout()" [disabled]="isLoggingOutComputed()" aria-label="Log out">
                <mat-icon>logout</mat-icon>
            </button>
        </div>
    </mat-toolbar>
</header>
<mat-divider></mat-divider>